import http from '../../../../libs/http'
const api = `${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/categories`
export default (payload = { name: '' }) => http.post(api, payload)
